"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestDataResponseToJSON = exports.TestDataResponseFromJSONTyped = exports.TestDataResponseFromJSON = exports.instanceOfTestDataResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the TestDataResponse interface.
 */
function instanceOfTestDataResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTestDataResponse = instanceOfTestDataResponse;
function TestDataResponseFromJSON(json) {
    return TestDataResponseFromJSONTyped(json, false);
}
exports.TestDataResponseFromJSON = TestDataResponseFromJSON;
function TestDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
    };
}
exports.TestDataResponseFromJSONTyped = TestDataResponseFromJSONTyped;
function TestDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
    };
}
exports.TestDataResponseToJSON = TestDataResponseToJSON;
